import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "inputGroup" }
const _hoisted_2 = { class: "groupTitle" }
const _hoisted_3 = { class: "inputGroup" }
const _hoisted_4 = { class: "groupTitle" }
const _hoisted_5 = { class: "inputGroup" }
const _hoisted_6 = { class: "groupTitle" }
const _hoisted_7 = { class: "groupInputs flex" }
const _hoisted_8 = { class: "groupInputs flex" }
const _hoisted_9 = { class: "inputRow" }
const _hoisted_10 = { class: "flex flex-wrap" }
const _hoisted_11 = ["checked", "id", "value"]
const _hoisted_12 = { class: "inputTitle ml-2" }
const _hoisted_13 = ["for"]
const _hoisted_14 = { class: "inputGroup" }
const _hoisted_15 = { class: "groupTitle" }
const _hoisted_16 = { class: "groupInputs flex" }
const _hoisted_17 = { class: "groupInputs flex" }
const _hoisted_18 = { class: "inputRow" }
const _hoisted_19 = { class: "flex flex-wrap" }
const _hoisted_20 = ["checked", "id", "value"]
const _hoisted_21 = { class: "inputTitle ml-2" }
const _hoisted_22 = ["for"]
const _hoisted_23 = { class: "inputGroup" }
const _hoisted_24 = { class: "groupTitle" }
const _hoisted_25 = { class: "groupInputs flex" }
const _hoisted_26 = { class: "groupInputs flex" }
const _hoisted_27 = { class: "inputRow" }
const _hoisted_28 = { class: "flex flex-wrap" }
const _hoisted_29 = ["checked", "id", "value"]
const _hoisted_30 = { class: "inputTitle ml-2" }
const _hoisted_31 = ["for"]
const _hoisted_32 = { class: "inputGroup" }
const _hoisted_33 = { class: "groupTitle" }
const _hoisted_34 = { class: "inputGroup" }
const _hoisted_35 = { class: "groupTitle" }
const _hoisted_36 = { class: "inputGroup" }
const _hoisted_37 = { class: "groupTitle" }
const _hoisted_38 = { class: "inputGroup" }
const _hoisted_39 = { class: "groupTitle" }
const _hoisted_40 = { class: "inputGroup" }
const _hoisted_41 = { class: "groupTitle" }

import FilterService from "@/utilities/services/FilterService";
import { TableType, ErrorLocationType } from "@/utilities/enums/Enums";
import { ref, computed, onMounted } from "vue";
import { useGlobalStore } from "@/stores/GlobalStore";
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import {Group1Service} from "@/utilities/services/entities/Group1Service";
import {Group2Service} from "@/utilities/services/entities/Group2Service";
import {ControlCenterService} from "@/utilities/services/entities/ControlCenterService";
import {AttributeFilter} from "@/models/AttributeFilter";
import {PermissionService} from "@/utilities/services/PermissionService";



export default /*@__PURE__*/_defineComponent({
  __name: 'LocationFilterPopup',
  setup(__props) {

const globalStore = useGlobalStore();
const group1Service = new Group1Service();
const group2Service = new Group2Service();
const permissionService = new PermissionService();
const controlCenterService = new ControlCenterService();

const userFilters = computed(()=>{
	return globalStore.userPreferences.userFilters;
});
const userHiddenColumns = computed(()=>{
	return globalStore.userPreferences.userHiddenColumns;
});


const tmpUserFilters = computed(()=>{
	return globalStore.tmpPreferences.tmpUserFilters;
});
const tmpUserHiddenColumns = computed(()=>{
	return globalStore.tmpPreferences.tmpUserHiddenColumns;
});


onMounted(()=>{
	//init tmp values
	globalStore.setTmpFilters(userFilters.value.filter(f => f.tableName === TableType[TableType.location]));
	globalStore.setTmpHiddenColumns(userHiddenColumns.value.filter(f => f.tableName === TableType[TableType.location]));

	// init afterFilters count
	globalStore.setCountAfterFilters(globalStore.gridStore?.count);
});



// init checkboxes according to tmpFilters [attributeValue == input-id]
const isFiltered = (attName, attVal) => {
	return tmpUserFilters.value.some(tuf => tuf.attributeName === attName && tuf.attributeValue === attVal.toString());
};

// init visibility buttons according to tmpHiddenColumns
const isHidden = (attName) => {
	return tmpUserHiddenColumns.value.some(thc => thc.attributeName === attName.toString());
};


const regionList = ref([]);
const setRegionList = async () =>{
  const resp = await group1Service.getRegions();
  if(resp === null || resp === undefined || resp.statusCode !== 0){
    ErrorHandler.handleError(resp, ErrorLocationType.popup);
    return;
  }

  regionList.value = resp.regionInfo;
};

const levelList = ref([]);
const setLevelList = async () =>{
  const resp = await group2Service.getLevels();
  if(resp === null || resp === undefined || resp.statusCode !== 0){
    ErrorHandler.handleError(resp, ErrorLocationType.popup);
    return;
  }

  levelList.value = resp.levelInfo;
};

const controlCenterList = ref([]);
const setControlCenterList = async () =>{
  const resp = await controlCenterService.getControlCenters();
  if(resp === null || resp === undefined || resp.statusCode !== 0){
    ErrorHandler.handleError(resp, ErrorLocationType.popup);
    return;
  }

  controlCenterList.value = resp.controlCenterInfo;
};


const filterChanged = ({ target }, propName) => {
	if(target.checked) {
		// add to tmpFilterList
		globalStore.addUserFilter(new AttributeFilter(TableType[TableType.location], propName, target.value.toString()));
	}
	else {
		// remove from tmpFilterList
		tmpUserFilters.value.forEach((tuf,index)=>{
			if(tuf.attributeName === propName && tuf.attributeValue === target.value.toString()) tmpUserFilters.value.splice(index, 1);
		});

		globalStore.setTmpFilters(tmpUserFilters.value);
	}

	calculateRestEntities();
};


const visibilityChange = (colName) => {
	if(!tmpUserHiddenColumns.value.some(thc => thc.attributeName === colName)) {
		// add to tmpHiddenColumnList
		globalStore.addUserHiddenColumn(new AttributeFilter(TableType[TableType.location], colName, ""));
	}
	else {
		// remove from tmpHiddenColumnList
		tmpUserHiddenColumns.value.forEach((thc,index)=>{
			if(thc.attributeName === colName) tmpUserHiddenColumns.value.splice(index, 1);
		});

		globalStore.setTmpHiddenColumns(tmpUserHiddenColumns.value);
	}

	calculateRestEntities();
};


const calculateRestEntities = () => {
	const allRecords = globalStore.gridStore.storage.allValues;
	const tmpFilterMethod = FilterService.buildFilter(TableType[TableType.location], true);

	let counter = 0;

	allRecords.forEach(r => {
		if (tmpFilterMethod(r)) counter++;
	});

	globalStore.setCountAfterFilters(counter);
};

onMounted(async () => {
  await setControlCenterList();
  await setRegionList();
  await setLevelList();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.locationFilter.secondaryId')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('secondaryId') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (visibilityChange('secondaryId')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.locationFilter.name')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('name') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (visibilityChange('name')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.locationFilter.group2Title')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('group2Name') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (visibilityChange('group2Name')))
        }, null, 2)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(levelList.value, (level) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "inputField flex w-1/3",
                  key: level
                }, [
                  _createElementVNode("input", {
                    checked: isFiltered('group2Id', level.id),
                    type: "checkbox",
                    id: 'level' + level.id.toString(),
                    value: level.id,
                    onChange: _cache[3] || (_cache[3] = (e) => filterChanged(e, 'group2Id'))
                  }, null, 40, _hoisted_11),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("label", {
                      for: 'level' + level.id.toString()
                    }, _toDisplayString(level.name), 9, _hoisted_13)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.locationFilter.group1Title')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('group1Name') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (visibilityChange('group1Name')))
        }, null, 2)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(regionList.value, (region) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "inputField flex w-1/3",
                  key: region
                }, [
                  _createElementVNode("input", {
                    checked: isFiltered('group1Id', region.id),
                    type: "checkbox",
                    id: 'region' + region.id.toString(),
                    value: region.id,
                    onChange: _cache[5] || (_cache[5] = (e) => filterChanged(e, 'group1Id'))
                  }, null, 40, _hoisted_20),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("label", {
                      for: 'region' + region.id.toString()
                    }, _toDisplayString(region.name), 9, _hoisted_22)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.locationFilter.controlCenter')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('controlCenterName') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[6] || (_cache[6] = ($event: any) => (visibilityChange('controlCenterName')))
        }, null, 2)
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controlCenterList.value, (center) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "inputField flex w-1/3",
                  key: center
                }, [
                  _createElementVNode("input", {
                    checked: isFiltered('controlCenterId', center.id),
                    type: "checkbox",
                    id: 'center' + center.id.toString(),
                    value: center.id,
                    onChange: _cache[7] || (_cache[7] = (e) => filterChanged(e, 'controlCenterId'))
                  }, null, 40, _hoisted_29),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("label", {
                      for: 'center' + center.id.toString()
                    }, _toDisplayString(center.name), 9, _hoisted_31)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.locationFilter.customAdditionalInfo')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('customAdditionalInformation') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[8] || (_cache[8] = ($event: any) => (visibilityChange('customAdditionalInformation')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.locationFilter.email')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('email') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[9] || (_cache[9] = ($event: any) => (visibilityChange('email')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.locationFilter.safetyInstruction')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('safetyInstructions') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[10] || (_cache[10] = ($event: any) => (visibilityChange('safetyInstructions')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", _hoisted_39, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.locationFilter.coupling')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('coupledSystemsName') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[11] || (_cache[11] = ($event: any) => (visibilityChange('coupledSystemsName')))
        }, null, 2)
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_40, [
      _createElementVNode("div", _hoisted_41, [
        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "icon-info" }, null, -1)),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('infoButton') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[12] || (_cache[12] = ($event: any) => (visibilityChange('infoButton')))
        }, null, 2)
      ])
    ], 512), [
      [_vShow, !_unref(permissionService).userHasPermission('Location.HideInfoColumn')]
    ])
  ]))
}
}

})